"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
exports.ALARM_CONFIG_TOKEN = new core_1.OpaqueToken('alarmConfigToken');
let InaxAlarmConfig = class InaxAlarmConfig {
    constructor(_http, _config) {
        this._http = _http;
        this._config = _config;
    }
    apply(config) {
        this._config = config;
    }
    createActiveAlarmFilterByConfigSettings() {
        if (this._config == null)
            return "1=1";
        let msgClassFilterResult = "";
        if (this._config.pendingAlarmMsgClassFilter != null) {
            this._config.pendingAlarmMsgClassFilter.forEach(msgClassFilter => {
                if (msgClassFilterResult.length > 0)
                    msgClassFilterResult += " OR ";
                msgClassFilterResult += "MsgClass=" + msgClassFilter;
            });
        }
        let stateFilerResult = "";
        if (this._config.pendingAlarmStateFilter != null) {
            this._config.pendingAlarmStateFilter.forEach(stateFilter => {
                if (stateFilerResult.length > 0)
                    stateFilerResult += " OR ";
                stateFilerResult += "StateAfter=" + stateFilter;
            });
        }
        let result = "";
        if (msgClassFilterResult.length > 0) {
            result += "(" + msgClassFilterResult + ")";
            if (stateFilerResult.length > 0)
                result += " AND ";
        }
        if (stateFilerResult.length > 0)
            result += "(" + stateFilerResult + ")";
        return result;
    }
    applyConfigSettingsOnAlarms(alarms) {
        if (this._config == null)
            return alarms;
        let cfg = this._config;
        alarms.forEach(alarm => {
            alarm.LineColore = cfg.defaultMsgColore;
            cfg.messageClasses.forEach(msgClass => {
                if (alarm.LineColore == cfg.defaultMsgColore && msgClass.id === alarm.MsgClass) {
                    alarm.LineColore = msgClass.colors[alarm.StateAfter];
                }
            });
        });
        return alarms;
    }
};
InaxAlarmConfig = __decorate([
    core_1.Injectable(),
    __param(1, core_1.Inject(exports.ALARM_CONFIG_TOKEN)),
    __metadata("design:paramtypes", [http_1.Http, Object])
], InaxAlarmConfig);
exports.InaxAlarmConfig = InaxAlarmConfig;
